import { FC, ReactNode } from "react";
import { default as MaterialChip } from "@mui/material/Chip";
import "./Chip.scss";

type ChipProps = {
  onClick?: () => void;
  className?: string;
  variant?:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  type?: "filled" | "outlined";
  onDelete?: () => void;
  children?: ReactNode;
};

const Chip: FC<ChipProps> = ({
  onClick,
  className,
  variant,
  type = "outlined",
  onDelete,
  children
}: ChipProps) => {
  return (
    <MaterialChip
      className={`${className}`}
      onClick={onClick}
      variant={type}
      color={variant}
      onDelete={onDelete}
      label={children}
    />
  );
};

export default Chip;
